import makeOrderXls from './makeOrderXls';

export default {
  makeOrderXls,
};
